import { api } from '../utils/apiClient';

export const getSettings = <T = any>(projectId: string): Promise<T> =>
  api.get<T>(`/settings?project_id=${projectId}`);

export const updateSettings = <T = any>(
  projectId: string,
  payload: unknown
): Promise<T> => api.put<T>(`/settings?project_id=${projectId}`, payload);
